import {useState} from 'react'
import {
    useUsid,
    useShopperContextsMutation,
    useShopperContext
} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

const useUpdateShopperContext = () => {
    const {usid} = useUsid()
    const {site} = useMultiSite()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const updateShopperContextMutation = useShopperContextsMutation('updateShopperContext')
    const createShopperContextMutation = useShopperContextsMutation('createShopperContext')

    const {data: shopperContext, isLoading} = useShopperContext(
        {parameters: {usid, siteId: site.id}},
        {enabled: !isServer && Boolean(usid)}
    )

    const updateShopperContext = async (storeId, storeDetails) => {
        setLoading(true)
        const body = {
            customQualifiers: {
                storeId,
                storeDetails
            }
        }
        const payload = {
            parameters: {usid, siteId: site.id},
            body
        }

        try {
            if (!shopperContext) {
                await createShopperContextMutation.mutateAsync(payload)
            } else {
                await updateShopperContextMutation.mutateAsync(payload)
            }
        } catch (error) {
            console.error('context error:', error)
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    return {
        updateShopperContext,
        loading,
        error,
        shopperContext,
        isShopperContextLoading: isLoading
    }
}

export default useUpdateShopperContext
